/** Furthest wizard breadcrumb that can be opened. Later steps stay closed until the one before them is saved. */
export function maxReachableWizardStep(
  lastCompletedStep: number,
  stepCount: number,
  profileComplete: boolean,
  expressSignupCompleted = false
): number {
  const lastIndex = Math.max(0, stepCount - 1);
  if (profileComplete) return lastIndex;
  // Express signup already saved the profile. The section breadcrumbs open;
  // Matching Starts stays closed until the profile is finished.
  if (expressSignupCompleted) return Math.max(0, lastIndex - 1);
  return Math.min(lastIndex, Math.max(0, lastCompletedStep + 1));
}
